<template>
  <div class="tabsContent1">

    <div class="sta-cav" style="height: 280px;">
      <div class="sta-title">

        <span class="time-select">
              <span>起止时间：</span>
            <el-date-picker
              v-model="sttm"
              value-format="yyyy-MM-dd"
              style="width: 180px"
              type="date"

            ></el-date-picker>
            -
            <el-date-picker
              style="width: 180px"
              v-model="edtm"
              value-format="yyyy-MM-dd"
              type="date"

            ></el-date-picker>
                  <span class="search-btn" @click="geteventlist()">查询</span>
                   <span class="search-btn" @click="geteventdatalist('week')">周数据</span>
                   <span class="search-btn" @click="geteventdatalist('month')">月数据</span>
              </span>
      </div>
      <div class="bom-cav" id="eventNum">

      </div>
    </div>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Vue from "vue";
import qs from "qs";

export default {
  name: "tabsContent1",
  data() {
    return {
      sttm:"",
      edtm:"",
      saveid:"",
    };
  },
  mounted() {

    this.saveid=sessionStorage.getItem('saveid');
    this.getnowtime()
    this.geteventlist()

  },
  methods: {
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date

      var yesnow = new Date();
      yesnow.setTime(yesnow.getTime() - 30 * 24 * 60 * 60 * 1000);
      var yesyear = yesnow.getFullYear(); //得到年份
      var yesmonth = yesnow.getMonth(); //得到月份
      var yesdate = yesnow.getDate(); //得到日期

      var yeshour = yesnow.getHours(); //得到小时
      var yesminu = yesnow.getMinutes(); //得到分钟
      var yessec = yesnow.getSeconds(); //得到秒
      var yesMS = yesnow.getMilliseconds(); //获取毫秒
      yesmonth = yesmonth + 1;
      if (yesmonth < 10) yesmonth = "0" + yesmonth;
      if (yesdate < 10) yesdate = "0" + yesdate;
      if (yeshour < 10) yeshour = "0" + yeshour;
      if (yesminu < 10) yesminu = "0" + yesminu;
      if (yessec < 10) yessec = "0" + yessec;
      if (yesMS < 100) yesMS = "0" + yesMS;
      var yestime = "";
      yestime =
        yesyear +
        "-" +
        yesmonth +
        "-" +
        yesdate
      this.sttm = yestime;
      this.edtm = time;
    },
    geteventlist(){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/monitorEventCountStatisByDate";
      param.data=qs.stringify({
        monitorSiteId:this.saveid,
        startDate:this.sttm,
        endDate:this.edtm,
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){
          that.getchart(res.data.eventNameCounts)
        }

      })
    },
    geteventdatalist(data){
      let paramdata=''
      if(data=="week"){
        paramdata="Week"
      }else if(data=="month"){
        paramdata="Month"
      }
      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/monitorEventCountStatis";
      param.data=qs.stringify({
        monitorSiteId:this.saveid,
        type:paramdata

      })
      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.getchart(res.data.eventNameCounts)
        }
      })
    },
    getchart(data){

      let myChart =this.$echarts.init(document.getElementById('eventNum'));

      let series=[]
      let xdata=[]
      let colorList=['rgba(24, 144, 255, 1)','rgba(47, 194, 91, 1)','rgba(250, 204, 20, 1)','rgba(250, 204, 255, 1)','rgba(55, 204, 20, 1)','rgba(250, 55, 20, 1)']
      for(let i=0;i<data.length;i++){
        // xdata.push()
        let seritem={
          type: 'bar',
          name: data[i].eventName,
          barMaxWidth: 20,
          stack: '总量',
          itemStyle: {
            normal: {
              color: colorList[i],
            }
          },
          data: []
        }
        for(let j=0;j<data[i].eventCountTrends.length;j++){
          if(i==0){
            xdata.push(data[i].eventCountTrends[j].dataTime)

          }
          seritem.data.push(data[i].eventCountTrends[j].count)
        }
        series.push(seritem)
      }

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        // title:{
        //   text:this.activecon,
        //   x: 'center',
        //   textStyle:{
        //     color : '#333',
        //     fontSize:24,
        //     fontWeight:700,
        //   },
        //   textAlign:"center",
        // },
        // dataZoom: [{
        //   type: 'slider',
        //   show: true,
        //   height: 20,
        //   left: '10%',
        //   right: '10%',
        //   bottom: '12%',
        //   start: 0,
        //   end: 100,
        //   textStyle: {
        //     color: '#000',
        //     fontSize: 11,
        //   },
        // }, {
        //   type: 'inside'
        // }
        //
        // ],
        grid: {
          right: '5%',

          left: '6%',
          top: '40px',
          containLabel: true
        },
        xAxis: [
          {
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            },
            //interval:0,
            //rotate:30
          },
        }],
        yAxis: [
          {
          type: 'value',

          nameTextStyle: {
            color: '#000'
          },
          position: 'left',
          minInterval: 1,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        }, ],
        series:series
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
  },
  watch: {
  },
  components: {}
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.tabsContent1{
  height: 100%;
}
.sta-cav{
  height:300px;

  padding-left: 30px;
}
.sta-title{
  font-size: 16px;
  position: relative;
  width: 860px;
  float: right;
  top: -40px;
  height: 50px;
  line-height: 50px;

  .time-select{
    float: right;
    margin-right: 40px;
  }
  .font-sp{
    font-weight: bold;
  }
}
#eventNum{
  width: 1600px;
  height: 340px;
}
.search-btn{
  display: inline-block;
  //width: 56px;
  padding: 0 10px;
  height: 28px;
  text-align: center;
  background-color: #5780fa;
  color: #fff;
  line-height: 28px;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
}
</style>

